

















































































































































































































import OtButton from '@/components/global/ot-button.vue';
import OtExpansionPanel from '@/components/global/ot-expansion-panel.vue';
import OtTag from '@/components/global/ot-tag.vue';
import OtApi, { executeApi } from '@/services/api.service';
import { vxm } from '@/store';
import { OtUserAction } from '@/types/action-enums';
import { OtDocumentReceivalType } from '@/types/document-receival-type';
import { getAconexDocumentLink, getAconexMailLink } from '@/utils/aconex-utils';
import { convertAndFormatDateAndTime, formatDateAndTime } from '@/utils/date-utils';
import downloadjs from 'downloadjs';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  AddEditDialogMode,
  AddEditDocumentDialogParams,
} from '../add-edit-document-dialog/add-edit-document-dialog-models';
import { DocumentDetails, DocumentFile, DocumentVersion } from '../document-models';

class FileWrapper {
  public file: DocumentFile;
  public progress: number;
  public isDownloading: boolean;
  constructor(file: DocumentFile) {
    this.file = file;
    this.progress = 0;
    this.isDownloading = false;
  }
  public setProgressFromEvent(e: ProgressEvent) {
    if (!e.lengthComputable) {
      this.progress = 0;
      return;
    }
    if (e.loaded >= e.total) {
      this.progress = 1;
      return;
    }

    this.progress = (e.loaded / e.total) * 100;
  }
}

@Component({
  components: {
    OtTag,
    OtButton,
    OtExpansionPanel,
  },
})
export default class OtDocumentDetails extends Vue {
  // * PROPS - not all of these are needed, so far this is used in the settings area, they'll be filled in by the router-view
  @Prop() private document?: DocumentDetails;
  @Prop() private version?: DocumentVersion;
  @Prop() private orgGid?: string;
  @Prop() private documentGid?: string; // woo, document AND the gid, as separate props, go team! And by Team, I mean me. Dan was foolish.

  // * REFS

  // * DATA
  private api = new OtApi();
  private files: FileWrapper[] = [];

  // * COMPUTED
  get isOtherReceivalType(): boolean {
    return this.version?.receivalType?.value === OtDocumentReceivalType.Other.value;
  }
  get canEditDocument() {
    return this.document?.availableActions.includes(OtUserAction.Edit);
  }
  get isMostRecentVersion() {
    const maxVersionIndex = Math.max(...(this.document?.versions.map(v => v.index) || [0]));
    return this.version?.index === maxVersionIndex;
  }
  get aconexMail() {
    return this.version?.aconexMailMetadata;
  }
  get hasAconexMail() {
    return Boolean(this.aconexMail);
  }
  get aconexDocument() {
    return this.version?.aconexDocumentMetadata;
  }
  get hasAconexDocument() {
    return Boolean(this.aconexDocument);
  }
  get aconexMailLink() {
    return this.aconexMail && this.aconexMail.projectId && this.aconexMail.mailId
      ? getAconexMailLink({
          projectId: this.aconexMail.projectId,
          mailId: this.aconexMail.mailId,
          originalAconexSite: this.aconexMail.userSite ?? null,
        })
      : null;
  }
  get aconexDocumentLink() {
    return this.aconexDocument && this.aconexDocument.projectId && this.aconexDocument.documentId
      ? getAconexDocumentLink({
          projectId: this.aconexDocument.projectId,
          documentId: this.aconexDocument.documentId,
          originalAconexSite: this.aconexDocument.userSite ?? null,
        })
      : null;
  }

  // * WATCHERS
  @Watch('version')
  private onVersionChange() {
    this.files = this.version?.files.map(f => new FileWrapper(f)) || [];
  }

  // * METHODS
  private convertAndFormatDateAndTime(date: Date | null, timeZone: string | null) {
    if (date && timeZone) {
      return convertAndFormatDateAndTime(date, timeZone, { overrideJoin: '-' });
    }
    return '';
  }
  private formatDate(date: Date | null) {
    if (date) {
      return formatDateAndTime(date, { excludeTime: true });
    }
    return '';
  }
  private formatDateAndTime(date: Date | null) {
    if (date) {
      return formatDateAndTime(date);
    }
    return '';
  }

  private async handleEditDocumentClick() {
    const params = new AddEditDocumentDialogParams({ documentGid: this.documentGid, mode: AddEditDialogMode.Edit });
    const result = await vxm.modal.openAddEditDocumentDialog(params);
    if (result && result.ok) {
      this.$emit('reloadDocument', async () => {
        await this.$nextTick();
        this.$router.push({ query: {} });
      });
    }
  }

  private get filesPanelTitle() {
    return this.version?.files.length
      ? 'Document files [' + this.version.files.length + ']'
      : 'Document files [no files]';
  }

  private async doDownload(file: FileWrapper) {
    const onDownloadProgress = (ev: ProgressEvent) => {
      console.log('download progress for key "' + file.file.gid + '"', ev);
      file.setProgressFromEvent(ev);
    };
    file.isDownloading = true;
    file.progress = 0;
    const apiResult = await executeApi(
      () => this.api.filesWithProgress().getFile(file.file.gid, undefined, onDownloadProgress),
      'Downloading File',
    );
    file.isDownloading = false;
    if (apiResult.success && apiResult.data) {
      const contentType =
        (apiResult.data.headers && apiResult.data.headers['content-type']) || 'application/octet-stream';
      const fileName = apiResult.data.fileName || file.file.name || 'download';

      downloadjs(apiResult.data.data, fileName, contentType);
    }
  }

  // * LIFECYCLE
  created() {
    this.onVersionChange();
  }
}
